// extracted by mini-css-extract-plugin
export default {"wrapper":"multiEditTableFooter_wrapper__12iXR"};